import { useTranslation } from "react-i18next";
import { OwnerFutureTab } from "@/components/owners/OwnerFutureTab";

interface PetSummary {
  id: string;
  name: string;
  status?: { name?: string | null } | null;
}

interface MobileOwnerCareTabProps {
  ownerId: string;
  petIds: string[];
  petSummaries: PetSummary[];
  clinicId: string | null;
  includeGrooming: boolean;
}

export function MobileOwnerCareTab({
  ownerId,
  petIds,
  petSummaries,
  clinicId,
  includeGrooming,
}: MobileOwnerCareTabProps) {
  const { t } = useTranslation("patients");
  if (petIds.length === 0) {
    return (
      <div className="bg-card border border-border/60 rounded-[20px] p-6 text-sm text-muted-foreground shadow-soft-card">
        {t("ownerProfile.futureEmpty")}
      </div>
    );
  }
  return (
    <OwnerFutureTab
      ownerId={ownerId}
      petIds={petIds}
      petSummaries={petSummaries}
      clinicId={clinicId}
      includeGrooming={includeGrooming}
    />
  );
}
